module.exports = __webpack_public_path__ + "img/位图(2).bfec39f9.png";